import { apiFetch } from "./http";

export async function fetchCurrentUser() {
    const res = await apiFetch("/user/me", {
        method: "GET"
    });

    return res.json();
}

export async function getGuestSession() {
    const res = await apiFetch("/user/guestSession", {
        method: "POST"
    });

    return res.json();
}

export async function updateUsername(newName: string) {
    const res = await apiFetch("/user/update_name", {
        method: "POST",
        body: JSON.stringify({ username: newName })
    });

    return res.json();
}

export async function getGameToken() {
    const res = await apiFetch("/user/getGameToken", {
        method: "POST"
    });

    return res.json();
}

export async function logout() {
    const res = await apiFetch("/user/logout", {
        method: "POST"
    });

    return res.json();
}
